import React, { useState } from 'react';
import { InputEmail } from '@jobber/components/InputEmail';
import { showToast } from '@jobber/components/Toast';
import { Button } from '@jobber/components/Button';
import { apiPost } from '../../api-client';
import { Heading } from '@jobber/components/Heading';
import { Link } from 'react-router-dom';
import { isValidEmail } from '../../components/Common/Validations';
import { Spinner } from '@jobber/components/Spinner';
import Footer from './Components/Footer';
import { useMutation } from '@tanstack/react-query';

function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const forgotPasswordMutation = useMutation({
    mutationFn: (data) => apiPost(`user/forgot-password`, data),
    onSuccess: (result) => {
      if (result.status) {
        showToast({ message: result.success || 'Reset link sent to your email', variation: 'success' });
        setSubmitted(true);
      } else {
        showToast({ message: result.error || result.message, variation: 'error' });
      }
    },
    onError: (error) => {
      showToast({ message: error.message || 'Failed to send reset link', variation: 'error' });
    }
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!email) {
      showToast({ message: 'Please provide an email', variation: 'error' });
      return;
    } else if (!isValidEmail(email)) {
      showToast({ message: 'Email is not valid', variation: 'error' });
      return;
    }

    forgotPasswordMutation.mutate({ email });
  };

  return (
    <div className="row">
      <div className="text-center mb-4">
        <Heading level={1}>JOBBER X THE ROYAL GATEWAY</Heading>
      </div>
      <div className="col-md-4"></div>
      <div className="col-md-4">
        <div className="d-flex justify-content-between mb-3">
          <Heading level={3}>Forget Password</Heading>
          <Link to={'/login'}>Back to Login</Link>
        </div>
        <div className="card">
          <div className="card-body">
            {submitted ? (
              <div className="text-center">
                <p>If an account exists with this email, a password reset link has been sent.</p>
                <div className="mt-3">
                  <Link to={'/login'}>
                    <Button label={'Return to Login'} />
                  </Link>
                </div>
              </div>
            ) : (
              <form onSubmit={submitHandler}>
                <p className="mb-3">Enter your email address and we'll send you a link to reset your password.</p>
                <InputEmail
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={setEmail}
                  validations={{
                    required: { value: true, message: 'Email is required' }
                  }}
                />
                <div className="mt-4">
                  {forgotPasswordMutation.isPending ? <Spinner size="base" /> : <Button label={'Send Reset Link'} submit />}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <div className="col-md-4"></div>
      <Footer />
    </div>
  );
}

export default ForgetPassword;